import React from 'react';

import { CommunicationType } from 'typings';
import { Button } from '@material-ui/core';

interface Props {
  isRevealed: boolean;
  revealContent: React.MouseEventHandler<HTMLButtonElement>;
  communicationType: CommunicationType;
}

const Inappropriate = ({ isRevealed, revealContent, communicationType }: Props) => {
  const text = `The following ${communicationType} includes potentially sensitive content.`;

  return (
    <span>
      {text}
      {isRevealed && (
        <Button color="primary" onClick={revealContent}>
          view
        </Button>
      )}
    </span>
  );
};

export default Inappropriate;
